/* eslint-disable no-debugger */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import Meetings from './modules/Meetings'
import TimeZone from './modules/TimeZone'
import User from './modules/User'
import Attendance from './modules/Attendance'
import moment from 'moment'

Vue.use(Vuex)
Vue.use(require('vue-moment'));

export default new Vuex.Store({
    state: {
        signedInUser: sessionStorage.getItem("userSignedIn") ? sessionStorage.getItem("userSignedIn") : false,
        events: false,
        access: true,
        showEventDetails: false,
        showMemberDetails: false,
        eventDisplay: false,
        meetingDisplay: false,
        scheduleDetails: {},
        // memberDisplay: false,
        coreGroup: false,
        coreGroupMembers: false,
        token: sessionStorage.getItem("authToken") ? sessionStorage.getItem("authToken") : undefined,
        personId: sessionStorage.getItem("personId") ? sessionStorage.getItem("personId") : '',
        roleId: sessionStorage.getItem("roleId") ? sessionStorage.getItem("roleId") : '',
        classSessionId: sessionStorage.getItem("classSessionId") ? sessionStorage.getItem("classSessionId") : '',
        coreGroupId: sessionStorage.getItem("coreGroupId") ? sessionStorage.getItem("coreGroupId") : '',
        isLoading: false,
        classTitle: "",
        coreGroupName: "",
        classId: sessionStorage.getItem("classId") ? sessionStorage.getItem("classId") : '',
        userId: sessionStorage.getItem("userId") ? sessionStorage.getItem("userId") : '',
    },
    mutations: {
        setSignedInUser: (state, value) => (state.signedInUser = value),
        setForbiddenAccess: (state) => (state.access = false),
        setEvents: (state, events) => (state.events = events),
        setEventDisplay: (state, event) => { state.eventDisplay = event },
        // setMeetingDisplay: (state, event) => { state.meetingDisplay = event },
        setScheduleDetails: (state, scheduleDetails) => { state.scheduleDetails = scheduleDetails},
        setMemberDisplay: (state, member) => { state.memberDisplay = member },
        setShowEventDetails: (state, value) => { state.showEventDetails = value },
        setShowMemberDetails: (state, value) => { state.showMemberDetails = value },
        setMeetings: (state, meetings) => (state.meetings = meetings),
        setCoreGroup: (state, coreGroup) => (state.coreGroup = coreGroup, state.coreGroupName = coreGroup.name),
        setCoreGroupMembers: (state, coreGroupMembers) => (state.coreGroupMembers = coreGroupMembers),
        setLoading: (state, value) => (state.isLoading = value),
        setPersonId: (state, value) => (state.personId = value),
        setUserId: (state, value) => (state.userId = value),
        setRoleId: (state, value) => (state.roleId = value),
        setClassSessionId: (state, value) => (state.classSessionId = value),
        setCoreGroupId: (state, value) => (state.coreGroupId = value),
        setClassTitle: (state, value) => (state.classTitle = value.classTitle),
        setClassId: (state, value) => (state.classId = value),
        setToken: (state, token) => (state.token = token),
  },
  actions: {
      signOut: ({commit}) => {
          console.log('signOut');
          commit('setToken', null)
          commit('setPersonId', 0)
          commit('setUserId', 0)
          commit('setRoleId', 0)
          localStorage.clear();
          sessionStorage.clear();
      },
    getAuthToken: ({ commit, state }) => {
      return new Promise((resolve, reject) => {

        axios.get(`/api/auth/token/${state.userId}/${state.roleId}`)
          .then(response => {
            resolve(response);
            console.log("token", response);
            sessionStorage.setItem("authToken", response.data.token);
            sessionStorage.setItem("expToken", response.data.expired_At);
            commit('setToken', response.data.token);
          })
          .catch(error => {
            reject(error);
            sessionStorage.removeItem("authToken");
          });
      });
    },
    fetchEvents: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        let data = {
          classSessionId: state.classSessionId
        };
        axios.post(`/api/proxy/events`, data)
          .then(respon => {
            let allEvents = respon.data.classEvents
            let filteredEvents = [];
            allEvents.forEach(oneEvent => {
              if(oneEvent.scheduleDetails.unix_start_time < moment().add(30, 'days').format("X")){
              if (state.coreGroup.name !== 'Leaders Council') {
                if (oneEvent.eventTypeID !== 2) {
                  filteredEvents.push(oneEvent);
                }
              } else {
                filteredEvents.push(oneEvent);
              }
            }
            });
            filteredEvents = filteredEvents.sort(function (a, b) {
              return a.scheduleDetails.unix_start_time - b.scheduleDetails.unix_start_time;
            });
            commit('setEvents', filteredEvents);
            const now = moment().unix();
            let closest = 999999999999;
            let eventSelected;
            filteredEvents.forEach(element => {
              if (element.scheduleDetails.unix_start_time >= now && element.scheduleDetails.unix_start_time < closest && element.eventTypeID !== 4) {
                closest = element.scheduleDetails.unix_start_time;
                eventSelected = element.classCalendarID;
              }
            });
            if (eventSelected !== undefined) {
              dispatch('fetchEvent', eventSelected);
              commit('setShowEventDetails', true);
              dispatch('fetchMeetings', {eventId : eventSelected, coreGroupId: state.coreGroupId});
              dispatch('fetchCoreGroupMembers', eventSelected);
              setTimeout(() => {
                document.querySelector('.noteBox.active').scrollIntoView({ block: "center", behavior: "smooth" });
              }, 600);
            }
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    fetchEvent: ({ commit }, eventID) => {
      return new Promise((resolve, reject) => {
        axios.post(`/api/proxy/events/${eventID}`)
          .then(respon => {
            console.log('EVENT', respon.data);
              commit('setEventDisplay', respon.data.classEvent)
              commit('setScheduleDetails', respon.data.classEvent.scheduleDetails)
          })
          .catch(error => {
            reject(error);
          })
      });
    },
    fetchCoreGroup: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        axios.post(`/api/proxy/coregroups/${state.coreGroupId}`)
          .then(respon => {
            let coregroup = respon.data.coreGroup;
            let sortedMembers = coregroup.coreGroupMembers;
            sortedMembers = sortedMembers.sort(function (a, b) {
              var textA = a.firstName.toUpperCase();
              var textB = b.firstName.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            coregroup.coreGroupMembers = sortedMembers;
            commit('setCoreGroup', coregroup);
            resolve(respon);
          })
          .catch(e => {
            reject(e);
          })
      });
    },
    fetchClass: ({ commit }, classId) => {
      return new Promise((resolve, reject) => {
        axios.get(`/api/proxy/class/${classId}`)
          .then(response => {
            console.log("classResponse", response.data);
            commit('setClassTitle', response.data.class);
          })
          .catch(e => {
            reject(e);
          })
      });
    },

    decryptData: ({ commit }, encryptedData) => {
      return new Promise((resolve, reject) => {
        let data = {
          EncryptedData: encryptedData
        };
        axios.post(`/api/auth/decrypt`, data)
          .then(response => {
            let resp = response.data;
            console.log("decrypted fisherData", resp);
            commit('setClassId', resp.classId);
            commit('setRoleId', resp.roleId);
            commit('setCoreGroupId', resp.coreGroupId);
            commit('setClassSessionId', resp.classSessionId);
            commit('setPersonId', resp.personId);
            commit('setUserId', resp.userId);

            sessionStorage.setItem("personId", resp.personId);
            sessionStorage.setItem("roleId", resp.roleId);
            sessionStorage.setItem("classSessionId", resp.classSessionId);
            sessionStorage.setItem("coreGroupId", resp.coreGroupId);
            sessionStorage.setItem("classId", resp.classId);
            sessionStorage.setItem("userId", resp.userId);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      });
    },

    fetchCoreGroupPeople: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        axios.post(`/api/people/coregroup/${state.coreGroupId}`)
          .then(respon => {
            let sortedMembers = respon.data.coreGroup.coreGroupMembers;
            sortedMembers = sortedMembers.sort(function (a, b) {
              var textA = a.firstName.toUpperCase();
              var textB = b.firstName.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            console.log('coreGroupResponse', sortedMembers);
            commit('setCoreGroupMembers', sortedMembers);
            let memberSelected = sortedMembers[0];
            if (memberSelected !== undefined) {
              commit('setMemberDisplay', memberSelected);
              commit('setShowMemberDetails', true);
              console.log(state.memberDisplay);
              setTimeout(() => {
                document.querySelector('.noteBox.active').scrollIntoView({ block: "center", behavior: "smooth" });
              }, 600);
            }
            resolve(respon);
          })
          .catch(e => {
            reject(e);
          })
      });
    },
  },
  getters: {
    allEvents: state => state.events,
    allMeetings: state => state.meetings,
    eventDisplay: state => state.eventDisplay,
    // meetingDisplay: state => state.meetingDisplay,
    memberDisplay: state => state.memberDisplay,
    showEventDetails: state => state.showEventDetails,
    showMemberDetails: state => state.showMemberDetails,
    getCoreGroupMembers: state => state.coreGroup.coreGroupMembers,
    getCoreGroupPeople: state => state.coreGroupMembers,
    getCoreGroup: state => state.coreGroup,
    isLoading: state => state.isLoading,
    classTitle: state => state.classTitle,
    coreGroupName: state => state.coreGroupName
  },
  modules: {
    Meetings,
    TimeZone,
    User,
    Attendance
  }
})
